export default __webpack_public_path__ + "static/media/Header03.62ad9002.jpg";